import { useState, useEffect, useCallback } from 'react';
import { dashboardUrl } from '../adminApi';
import { adminFetchJson } from '../adminFetch';

/**
 * Loads the admin dashboard payload for a given product context ('pnc' |
 * 'shopmanual'), from that product's backend.
 */
export default function useAdminData(context = 'pnc') {
  const [data,    setData]    = useState(null);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState(null);

  const fetchData = useCallback(() => {
    return adminFetchJson(dashboardUrl(context))
      .then(d => { setData(d); setError(null); setLoading(false); })
      .catch(e => { setError(e.message); setLoading(false); });
  }, [context]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, loading, error, refetch: fetchData };
}
